{
  "instances": {
    "logfile": {
      "label": "Лог-файл",
      "download": "Загрузить",
      "wrap_lines": "Перенос строк",
      "page_up": "Страница вверх",
      "page_down": "Страница вниз",
      "previous_chunk": "Предыдущий фрагмент",
      "next_chunk": "Следующий фрагмент",
      "resume_follow": "Возобновить слежение",
      "stop_follow": "Остановить слежение",
      "reconnecting": "Повторное подключение...",
      "compressed_reset": "Файл журнала сжат, страница сбрасывается"
    }
  }
}
